import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none", stroke: "#43a047", strokeWidth: 2, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 10, fill: "#43a047", opacity: 0.15 }), /* @__PURE__ */ React.createElement("path", { d: "M8 12l2 2 4-4", stroke: "#43a047", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgSuccess);
export default ForwardRef;
